import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';
import ToggleDefault from '~/components/ToggleDefault';
import { InputPercent, InputSelect } from '~/components/NovosInputs';
import { moedaFormatada } from '~/components/NovosInputs/InputMoney/formatMask';
import { useProduto } from '~/pages/Produto/hooks/useProduto';
import { FlagsState } from '~/pages/Produto/types/index';
import { useProdutoQueries } from '~/pages/Produto/hooks/useQueriesProduto';

export const AbaIcms: React.FC = () => {
  const {
    formProdutoLoja,
    changeFormProdutoLoja,
    register,
    control,
    setValue,
    formState: { errors },
    flags,
    ChangeFlags,
  } = useProduto();

  const { tribEntrada, tribSaida } = useProdutoQueries();

  return (
    <>
      <Row>
        <Col sm={12} md={12} lg={12} xl={12}>
          <InputSelect
            label="ICMS Entrada"
            placeholder="Selecione o NCM"
            name="cod_trib_entrada"
            register={register}
            isError={!!errors.cod_trib_entrada}
            control={control}
            options={tribEntrada.data as SelectType[]}
            changeSelected={() => null}
            isDisabled
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col sm={12} md={2} lg={2} xl={2}>
          <ToggleDefault
            labelOnRight
            inLine
            labelText="Crédito Vedado"
            setChecked={flags.flg_veda_cred}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_veda_cred: !prev.flg_veda_cred,
                flg_veda_cred_lim: prev.flg_veda_cred
                  ? false
                  : prev.flg_veda_cred_lim,
              }));
              setValue(
                'per_veda_cred_lim',
                flags.flg_veda_cred
                  ? ''
                  : formProdutoLoja.per_veda_cred_lim.value,
              );
              changeFormProdutoLoja({
                ...formProdutoLoja,
                per_veda_cred_lim: {
                  ...formProdutoLoja.per_veda_cred_lim,
                  value: flags.flg_veda_cred
                    ? '0,00'
                    : formProdutoLoja.per_veda_cred_lim.value,
                },
              });
            }}
          />
        </Col>
        <Col sm={12} md={2} lg={2} xl={2}>
          <ToggleDefault
            labelOnRight
            inLine
            labelText="Até o Limite de"
            disabled={!flags.flg_veda_cred}
            setChecked={flags.flg_veda_cred_lim}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_veda_cred_lim: !prev.flg_veda_cred_lim,
              }));
              changeFormProdutoLoja({
                ...formProdutoLoja,
                per_veda_cred_lim: {
                  ...formProdutoLoja.per_veda_cred_lim,
                  value: formProdutoLoja.flg_veda_cred_lim.value
                    ? '0,00'
                    : formProdutoLoja.per_veda_cred_lim.value,
                },
              });
              setValue('per_veda_cred_lim', '0,00');
            }}
          />
        </Col>
        <Col sm={12} md={2} lg={2} xl={2}>
          <div>
            <InputPercent
              min={0}
              max={100}
              maxLength={5}
              decimals={2}
              autoComplete="off"
              placeholder="0,00"
              control={control}
              isDisabled={!flags.flg_veda_cred || !flags.flg_veda_cred_lim}
              name="per_veda_cred_lim"
              register={register}
              isError={!!errors.per_veda_cred_lim}
              showIcon
              onInput={(ev: any) => {
                const serializedValue = moedaFormatada(ev.target.value);

                let valueToFloat = '';

                if (serializedValue.length < 7) {
                  valueToFloat = serializedValue.replace(',', '.');
                } else {
                  valueToFloat = serializedValue.replace('.', '');
                  valueToFloat = valueToFloat.replace(',', '.');
                }

                setValue('per_veda_cred_lim', valueToFloat);
                changeFormProdutoLoja({
                  ...formProdutoLoja,
                  per_veda_cred_lim: {
                    ...formProdutoLoja.per_veda_cred_lim,
                    value: valueToFloat.includes('-')
                      ? valueToFloat.replace('-', '')
                      : valueToFloat,
                  },
                });
              }}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12} lg={12} xl={12}>
          <InputSelect
            label="ICMS Saída"
            placeholder="Selecione o NCM"
            name="cod_tributacao"
            register={register}
            isError={!!errors.cod_tributacao}
            control={control}
            options={tribSaida.data as SelectType[]}
            changeSelected={() => null}
            isDisabled
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12} lg={12} xl={12} className="mt-2">
          <ToggleDefault
            labelOnRight
            inLine
            toggleTitle="Habilitado apenas para tributações do tipo SUBSTITUIÇÃO"
            labelText="Produção Própria (destaca ST na NF de Cliente)"
            disabled={formProdutoLoja.cod_tributacao.value.value !== 3}
            setChecked={false}
            onSwitch={() => false}
          />
        </Col>
      </Row>
    </>
  );
};
